import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit, output, signal } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { SystemAdminService } from "../../../../services/system-admin.service";
import { UserConfigDetails } from "../../../../models/SystemAdmin.model";
import { MatExpansionModule } from "@angular/material/expansion";
import { response } from "express";

@Component({
    selector: 'app-user-config',
    standalone: true,
    imports: [CommonModule, MatExpansionModule, ReactiveFormsModule],
    templateUrl: './user-config.component.html',
    styleUrl: './user-config.component.scss'
})
export class UserConfigComponent implements OnInit {
  @Input() userConfigForm!: FormGroup;
  @Input() userId!: string;
  @Input() isCreateUser!: boolean;
  userConfigSubmitEmitter = output<boolean>(); 
  cancelEmitter = output<boolean>(); 
  setupLinkEmitter = output<boolean>(); 
  resetLinkEmitter = output<boolean>(); 
  isLocked = signal(false)
  systemAdminService = inject(SystemAdminService);
  ngOnInit(): void {
    if(this.userId){
      this.fetchUserConfigDetails(this.userId);
    }
  }

  fetchUserConfigDetails(userId: string) {
    this.systemAdminService.getUserConfig(userId).subscribe({
      next: (response: UserConfigDetails) => {
          if(response){
            response.isLocked === 0 ? this.isLocked.set(true) : this.isLocked.set(false)
            this.userConfigForm.patchValue({
              isEmailverified: response?.isEmailverified ? response?.isEmailverified : 0,
              isQrValidated: response?.isQrValidated ? response?.isQrValidated : 0,
              isResetVerified: response?.isResetVerified ? response?.isResetVerified : 0,
              isLocked: response?.isLocked ? response?.isLocked : 0
            });
          }
      },
      error: (error: any) => {
        console.log("error", error);
      }
    });
  }

 

  onSetupLink(){
    this.setupLinkEmitter.emit(true);
  }

  onResetLink(){
    this.resetLinkEmitter.emit(true);
  }

  onCancel() {
    this.cancelEmitter.emit(true);  
  }

  onSubmit() {
    this.userConfigSubmitEmitter.emit(true);
  }

  onQrLink() {
    const currentQrValue = this.userConfigForm.get('isQrValidated')?.value === 1;
    const reversedQrValue = currentQrValue ? 0 : 1; // Reverse the value
  
    this.userConfigForm.patchValue({ isQrValidated: reversedQrValue });
    this.userConfigSubmitEmitter.emit(true); // Trigger the submit with the reversed value
  }

  onSystemLock() {
    const currentLockValue = this.userConfigForm.get('isLocked')?.value === 1;
    const reversedLockValue = currentLockValue ? 0 : 1; // Reverse the value
  
    this.userConfigForm.patchValue({ isLocked: reversedLockValue });
    this.userConfigSubmitEmitter.emit(true); // Trigger the submit with the reversed value
  }

  onResetSession(){
    this.systemAdminService.resetUserSession(Number(this.userId)).subscribe({
      next:(response) => {
        if(response){
          this.userConfigSubmitEmitter.emit(true);
        }
      }
    })
  }

}